export default __webpack_public_path__ + "static/media/Language.def04858.png";